import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import componentStyles from "./youtube-cta-component.scss";
import PlayIcon from "/static/svg/play_icon_white.svg";
import YoutubeVideoModalComponent from "/components/core/youtube-video-modal/youtube-video-modal-component";
import { YOUTUBE_MODAL_OPEN, YOUTUBE_MODAL_CLOSE } from "/constants/bigbrain-event-types";
import Button from "/components/core/button/button-component";
const BIGBRAIN_SECOND_CTA_KIND = "second-cta";
class YoutubeCtaComponent extends PureComponent {
    onPlayButtonClicked() {
        BigBrain("track", YOUTUBE_MODAL_OPEN, {
            kind: BIGBRAIN_SECOND_CTA_KIND
        });
        this.setState({
            openModal: true
        });
    }
    closeModal() {
        BigBrain("track", YOUTUBE_MODAL_CLOSE, {
            kind: BIGBRAIN_SECOND_CTA_KIND
        });
        this.setState({
            openModal: false
        });
    }
    renderButtonContent() {
        const { playButtonText } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "button-content",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "play-icon",
                    children: /*#__PURE__*/ _jsx(PlayIcon, {})
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "play-text",
                    children: [
                        " ",
                        playButtonText
                    ]
                })
            ]
        });
    }
    render() {
        const { videoId, footerText, width, height, autoplay, buttonColor, buttonSize } = this.props;
        const { openModal } = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "youtube-cta-wrapper",
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    className: "watch-video-button",
                    color: buttonColor,
                    size: buttonSize,
                    onClickCallback: this.onPlayButtonClicked,
                    children: this.renderButtonContent()
                }),
                /*#__PURE__*/ _jsx(YoutubeVideoModalComponent, {
                    footerText: footerText,
                    videoId: videoId,
                    isOpen: openModal,
                    opts: {
                        width: width,
                        height: height,
                        playerVars: {
                            autoplay: autoplay,
                            rel: 0,
                            showinfo: 0
                        }
                    },
                    onCloseModal: this.closeModal
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            openModal: false
        };
        this.onPlayButtonClicked = this.onPlayButtonClicked.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.renderButtonContent = this.renderButtonContent.bind(this);
    }
}
export { YoutubeCtaComponent as default };
YoutubeCtaComponent.defaultProps = {
    width: 970,
    height: 546,
    autoplay: 1,
    buttonColor: "brand-blue",
    buttonSize: "md"
};
